import { TemplateSourceEnum } from "./WhatsappInboxTypes";

export interface WhatsappTemplatesState {
    templates: WhatsAppTemplate[];
    loading: boolean;
    error: string | null;
    filters: TemplatesListFilters;
    currentTemplate: WhatsAppTemplate | null;
    showDeleteWhatsappTemplateModal: boolean;
    showSubmitWhatsappTemplateModal: boolean;
}


export enum TemplateStatus {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

export enum TemplateCategory {
    UTILITY = 'UTILITY',
    MARKETING = 'MARKETING',
}

export type TemplateLanguage = 'en' | 'ar';

export interface WhatsAppTemplate {
    id: string;
    partnerId: number;
    name: string;
    category: TemplateCategory;
    language: TemplateLanguage;
    components: Record<string, any>;
    status: TemplateStatus;
    isSystemTemplate: boolean;
    requiredPlaceholders?: RequiredPlaceholdersEnum[];
    approvedAt?: string;
    rejectedAt?: string;
    rejectionReason?: string;
    createdByUserId?: number;
    isShared: boolean;
    version: number;
    createdAt: string;
    updatedAt: string;
    categoryChangedByMeta?: boolean;
}

export enum RequiredPlaceholdersEnum {
    CANDIDATE_NAME = 'CANDIDATE_NAME',
    COMPANY_NAME = 'COMPANY_NAME',
    JOB_TITLE = 'JOB_TITLE',
    JOB_LOCATION = 'JOB_LOCATION',
    RECRUITER_NAME = 'RECRUITER_NAME',
}

export interface CreateTemplateRequest {
    name: string;
    category: TemplateCategory;
    language: TemplateLanguage;
    templatePayload: string;
    is_shared?: boolean;
}

export interface UpdateTemplateRequest {
    name: string;
    category: TemplateCategory;
    language: TemplateLanguage;
    templatePayload: string;
}


export interface TemplatesListFilters {
    status?: TemplateStatus;
    source?: TemplateSourceEnum;
    isSystemTemplate?: boolean;
    search?: string;
    page?: number;
    limit?: number;
}

export interface TemplatesListResponse {
    templates: WhatsAppTemplate[];
    total: number;
    systemTemplatesCount: number;
    customTemplatesCount: number;
}

/**
 * Allowed named placeholders for WhatsApp templates
 * These match the backend TemplatePlaceholder enum
 *
 * IMPORTANT: Only these placeholders are allowed in templates.
 * Positional placeholders ({{1}}, {{2}}, etc.) are deprecated.
 * The system will auto-resolve these values from conversation/worker/partner data.
 */
export const WHATSAPP_TEMPLATE_PLACEHOLDERS = {
    candidate_name: 'Candidate Name',
    job_title: 'Job Title',
    job_location: 'Job Location',
    interview_time: 'Interview Time',
    meeting_link: 'Meeting Link',
    recruiter_name: 'Recruiter Name',
    application_source: 'Application Source',
    company_name: 'Company Name',
} as const;

export type TemplatePlaceholder = keyof typeof WHATSAPP_TEMPLATE_PLACEHOLDERS;

export const TEMPLATE_BODY_MAX_LENGTH = 1000;


export enum TemplatePlaceholderEnum {
    CANDIDATE_NAME = 'CANDIDATE_NAME',
    COMPANY_NAME = 'COMPANY_NAME',
    JOB_TITLE = 'JOB_TITLE',
    JOB_LOCATION = 'JOB_LOCATION',
    RECRUITER_NAME = 'RECRUITER_NAME',
    CONTRACT_TYPE = 'CONTRACT_TYPE',
    INTERVIEW_INVITATION_LINK = 'INTERVIEW_INVITATION_LINK',
    INTERVIEW_INVITATION_SELECTED_SLOT = 'INTERVIEW_INVITATION_SELECTED_SLOT',
    // INTERVIEW_TIME = 'INTERVIEW_TIME',
    // MEETING_LINK = 'MEETING_LINK',
    // APPLICATION_SOURCE = 'APPLICATION_SOURCE',
}

export const whatsappTemplatePlaceHolders = [
    {
        id: TemplatePlaceholderEnum.CANDIDATE_NAME,
        content: {
            ar: "اسم المرشح",
            en: "Candidate Name"
        },
    },
    {
        id: TemplatePlaceholderEnum.COMPANY_NAME,
        content: {
            ar: "اسم الشركة",
            en: "Company Name"
        },
    },
    {
        id: TemplatePlaceholderEnum.JOB_LOCATION,
        content: {
            ar: "موقع العمل",
            en: "Job Location"
        },
    },
    {
        id: TemplatePlaceholderEnum.JOB_TITLE,
        content: {
            ar: "المسمى الوظيفي",
            en: "Job Title"
        },
    },
    {
        id: TemplatePlaceholderEnum.RECRUITER_NAME,
        content: {
            ar: "اسم مسؤول التوظيف",
            en: "Recruiter Name"
        },
    },
    {
        id: TemplatePlaceholderEnum.CONTRACT_TYPE,
        content: {
            ar: "نوع العقد",
            en: "Contract Type"
        },
    },
    {
        id: TemplatePlaceholderEnum.INTERVIEW_INVITATION_LINK,
        content: {
            ar: "رابط المقابلة",
            en: "Interview Invitation Link"
        },
    },
    {
        id: TemplatePlaceholderEnum.INTERVIEW_INVITATION_SELECTED_SLOT,
        content: {
            ar: "موعد المقابلة",
            en: "Interview Invitation Selected Slot"
        },
    },
];